export default {
  items: [
    {
      name: 'Bürgermeldungen',
      url: '/reports',
      icon: 'icon-doc',
      accessRight: 'manager',
    },
    {
      name: 'Gemeindemeldungen',
      url: '/topics',
      icon: 'icon-list',
      accessRight: 'manager',
    },
    {
      name: 'Regionsmeldungen',
      url: '/topics',
      icon: 'icon-list',
      accessRight: 'groupLeader',
    },
    {
      name: 'Umfragen',
      url: '/surveys',
      icon: 'icon-pie-chart',
    },
    {
      name: 'Termine',
      url: '/appointments',
      icon: 'icon-calendar',
      accessRight: 'manager',
    },
    {
      name: 'Mitarbeiter',
      url: '/employees',
      icon: 'icon-user',
      accessRight: 'assignments',
    },
    {
      name: 'Aufgaben',
      url: '/assignments',
      icon: 'icon-check',
      accessRight: 'assignments',
    },
    {
      name: 'Logbuch',
      url: '/log',
      icon: 'icon-notebook',
      accessRight: 'manager',
    },
    {
      divider: true,
    },
    {
      name: 'Abmelden',
      url: '/login',
      icon: 'icon-logout',
      class: 'mt-auto',
      variant: 'danger',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js